export default __webpack_public_path__ + "b8cd18762241252dd67ae97a229ded94.png";